module.exports = __webpack_public_path__ + "img/zgxq1.411d930e.png";